import React from 'react'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PopInRightPanel from '../components/PopInRightPanel';
import CustomerTable from '../components/CustomerTable';

function Profile() {
  return (
    <>
    <main className="main-content border-radius-lg ">
    <NavBar/>   
    <CustomerTable/>
    <Footer/>
    </main>
    <PopInRightPanel/>
    </>
  )
}

export default Profile
